import {
    Box,
    CircularProgress,
    Grid,
    Tooltip,
    Typography,
} from "@mui/material";
import React, { useMemo, useState } from "react";
import { useDropzone } from "react-dropzone";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import EditIcon from "@mui/icons-material/Edit";
import { BANNER_ACCEPTED_FILE } from "../../Pages/LandingPage/constants";
import DeleteIcon from "@mui/icons-material/DeleteForeverRounded";

const baseStyle = {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderWidth: 2,
    borderRadius: 2,
    borderColor: "#eeeeee",
    borderStyle: "dashed",
    backgroundColor: "#fafafa",
    color: "#bdbdbd",
    outline: "none",
    transition: "border .24s ease-in-out",
};

const focusedStyle = {
    borderColor: "#2196f3",
};

const acceptStyle = {
    borderColor: "#1976d2",
    backgroundColor: "rgb(222 222 222)",
};

const rejectStyle = {
    borderColor: "#ff1744",
};

const defaultheight = 200;

export function StyledDropzone(props: any) {
    const {
        multiple,
        onDropFile,
        imageUrl,
        placeholderMessage,
        errorMessage,
        loader,
        disabled,
        onRemoveImage,
        height,
        loaderHeight = 200,
        errorOutline,
    } = props;
    const {
        getRootProps,
        getInputProps,
        isFocused,
        isDragAccept,
        isDragReject,
        open,
    } = useDropzone({
        accept: {
            [BANNER_ACCEPTED_FILE[0]]: [],
            [BANNER_ACCEPTED_FILE[1]]: [],
            [BANNER_ACCEPTED_FILE[2]]: [],
        },
        multiple: multiple || false,
        noClick: (imageUrl && true) || false,
        onDrop: (files) => onDropFile(files),
        disabled,
    });

    const style: any = useMemo(
        () => ({
            ...baseStyle,
            ...(height ? { height: `${height}px` } : {}),
            ...(errorOutline ? { border: "1px solid red" } : {}),
            ...(isFocused ? focusedStyle : {}),
            ...(isDragAccept ? acceptStyle : {}),
            ...(isDragReject ? rejectStyle : {}),
        }),
        [isFocused, isDragAccept, isDragReject, errorOutline]
    );

    const getName = (url: string) => {
        if (url) {
            const matches = url.match(/\/([^/]+)$/);
            if (matches && matches.length > 1) {
                const nameSplit = matches[1].split("__");
                const extension = matches[1].split(".")[1];
                return nameSplit[0] + "." + extension;
            }
        }
        return "";
    };

    return (
        <div className="container">
            {!loader ? (
                <div {...getRootProps({ style })}>
                    <input {...getInputProps()} />
                    {imageUrl ? (
                        <Box
                            component="img"
                            className="banner-form-image"
                            sx={{
                                height,
                            }}
                            alt="Image"
                            src={imageUrl}
                        />
                    ) : (
                        <Grid
                            className="banner-card-image d-flex flex-column j-center align-item-center"
                            item
                        >
                            <FileUploadIcon />
                            Upload Image
                        </Grid>
                    )}

                    {/* <p>Drag 'n' drop some files here, or click to select files</p> */}
                </div>
            ) : (
                <div
                    className={`d-flex j-center align-item-center h-${loaderHeight}p`}
                >
                    <CircularProgress />
                </div>
            )}

            {!imageUrl ? (
                (errorMessage && <></>) ||
                (!loader && (
                    <div className="j-space">
                        <h5 className={`text-align ${errorOutline && "red"}`}>
                            {placeholderMessage}
                        </h5>
                    </div>
                ))
            ) : (
                <div className="d-flex j-space">
                    <Typography
                        className="banner-form-image-label"
                        variant="subtitle1"
                    >
                        {getName(imageUrl)}
                    </Typography>
                    {!disabled && (
                        <div className="d-flex w-50p">
                            <Tooltip title="Edit">
                                <EditIcon
                                    className="cursor-pointer"
                                    onClick={open}
                                />
                            </Tooltip>
                            <Tooltip title="Delete">
                                <DeleteIcon
                                    className="cursor-pointer"
                                    onClick={onRemoveImage}
                                />
                            </Tooltip>
                        </div>
                    )}
                </div>
            )}
            {errorMessage && <h5 className="text-danger">{errorMessage}</h5>}
        </div>
    );
}
